module.exports = __webpack_public_path__ + "img/LighteningCardScreenshot-1250h.886c6fc2.png";